import React from "react";

interface IntegrationCard {
    logo: string;
    title: string;
    subtext: string;
    description: string;
    link: string;
    new?: boolean;
}

const IntegrationCard: React.FC<{ items: IntegrationCard[] }> = ({ items }) => {
    return (
        <div className="flex lg:flex-wrap lg:flex-row flex-col items-center">
            {items.map((item, index) => (
                <div
                    key={index}
                    className={`${item.new ? "bg-gray-100" : "bg-blue-50"} text-left p-5`}
                    style={{ width: "278px", height: "290px", borderRadius: "6px", marginLeft: "20px", marginRight: "20px", marginBottom: "20px", flex: "0 0 calc(25% - 40px)" }}
                >
                    <div className="w-full flex flex-col space-y-4">
                        <div className="flex flex-row items-center w-full">
                            <div className="bg-white w-20 h-20 mr-4">
                                <img src={item.logo} alt={`${item.title} logo`} />
                            </div>
                            <div className="w-1/2">
                                <div className=" font-bold text-gray-700">{item.title}</div>
                                <div className=" text-base text-gray-500">{item.subtext}</div>
                            </div>
                        </div>

                        <div className="text-base text-blue-500">
                            <div className=" text-base text-gray-500 h-20">{item.description}</div>
                            <a
                                href={item.link}
                                target="_blank"
                                rel="noreferrer"
                                className="pt-14 text-blue-500 hover:underline justify-start"
                                style={{ display: "inline-flex", alignItems: "center" }}
                            >
                                Learn More
                                <span style={{ marginLeft: "4px" }}>{">"}</span>
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default IntegrationCard;
